module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('payment-method-id')) ? _c('div', {
    staticClass: "field-payment-method-id"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ID")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.id) + " " + _vm._s(_vm.item.uid))])]) : (_vm.$is('payment-method-name')) ? _c('div', {
    staticClass: "field-payment-method-id"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Payment method Name")]), _c('div', {
    staticClass: "field-value"
  }, [_c('a', {
    on: {
      "click": _vm.viewPMOnGateway
    }
  }, [_vm._v(_vm._s(_vm.item.name))])])]) : (_vm.$is('payment-method-provider')) ? _c('div', {
    staticClass: "field-payment-method-id"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Provider")]), _c('div', {
    staticClass: "field-value"
  }, [_c('a', {
    on: {
      "click": _vm.viewClientOnGateway
    }
  }, [_vm._v(_vm._s(_vm.item.provider))])])]) : (_vm.$is('payment-method-created')) ? _c('div', {
    staticClass: "field-payment-method-id"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, "DD/MM/YYYY hh:mm")))])]) : (_vm.$is('payment-method-updated')) ? _c('div', {
    staticClass: "field-payment-method-id"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Updated")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.updated, "DD/MM/YYYY hh:mm")))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb0b494c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/PaymentMethodFields.vue
// module id = 2701
// module chunks = 1